import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VTextField,
    _vm._g(
      _vm._b(
        {
          scopedSlots: _vm._u(
            [
              {
                key: "prepend-inner",
                fn: function () {
                  return [
                    _vm._t("prepend-inner", function () {
                      return [
                        _c(
                          VIcon,
                          {
                            staticClass: "icon-secondary--text mr-2",
                            attrs: { size: "20" },
                          },
                          [_vm._v("\n        ui-icon-search\n      ")]
                        ),
                      ]
                    }),
                  ]
                },
                proxy: true,
              },
            ],
            null,
            true
          ),
        },
        "v-text-field",
        {
          height: 48,
          dense: true,
          solo: true,
          flat: true,
          clearable: true,
          hideDetails: true,
          backgroundColor: "bg-gray-40",
          class: "core-search-field",
          "data-qa": "core-search-field",
          ..._vm.$attrs,
        },
        false
      ),
      {
        ..._vm.$listeners,
        input: _setup.handleInput,
      }
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }